import { TimeFill18Icon } from "@vygruppen/spor-icon-react";
import type { ColorScheme } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/types";
import { FC } from "react";
import {
  DropsButton,
  Flex,
  HStack,
  Text,
  tokens,
} from "shared/components/Spor";
import {
  InfrastructureOperationalInformationOverviewResponse,
  TrainOperationalInformationOverviewResponse,
} from "shared/types/operationalInformation";
import { formatTimeString } from "shared/utils/dateTimeUtils";

type EventTimeInfoProps = {
  event:
    | InfrastructureOperationalInformationOverviewResponse
    | TrainOperationalInformationOverviewResponse;
  colorScheme: ColorScheme;
  changed: boolean;
  onShowChanges: () => void;
};

export const EventTimeInfo: FC<EventTimeInfoProps> = ({
  event,
  colorScheme,
  changed,
  onShowChanges,
}) => (
  <HStack width="100%" gap={tokens.default.size.spacing[2]}>
    <HStack
      gap={tokens.default.size.spacing[1]}
      alignItems="center"
      width="100%"
    >
      <Flex
        flexDirection="row"
        flexWrap="wrap"
        alignItems="center"
        gap={tokens.default.size.spacing[1]}
        width="100%"
      >
        <Flex gap={tokens.default.size.spacing[1]} alignItems="center">
          <TimeFill18Icon
            color={colorScheme.textColorSecondary}
            minWidth="18px"
            mt="2px"
          />
          <Text
            variant="xs"
            color={colorScheme.textColorSecondary}
            fontWeight="normal"
          >
            <b>{formatTimeString(event.createdAt)}</b> |
          </Text>
        </Flex>
        <Text
          variant="xs"
          color={colorScheme.textColorSecondary}
          fontWeight="normal"
        >
          Sist oppdatert: {formatTimeString(event.updatedAt)}
        </Text>
      </Flex>
      {changed && (
        <DropsButton
          size="xs"
          variant="primary"
          semantics="warning"
          onClick={(e) => {
            e.stopPropagation();
            onShowChanges();
          }}
          ml="auto"
          mr="0px"
          minWidth="91px"
        >
          Vis endring
        </DropsButton>
      )}
    </HStack>
  </HStack>
);
